export default __webpack_public_path__ + "static/SCROLL_9-27c221ad9f96757322a9b1c73743324f.png";